module.exports = __webpack_public_path__ + "static/t_324_719-10755d382907f59d9a2e6da4f1361a75.png";